import styled from 'styled-components';
import { mq } from '../../../stylesheets/tools';

const StyledCurtain = styled.div`
  position: relative;

  .curtain__right,
  .curtain__left {
    position: fixed;
    height: 120vh;
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: transform 0.2s cubic-bezier(0.48, 0, 0.5, 1);
  }

  .curtain__left {
    width: 150vw;
    top: 70vh;
    left: 0;
    transform: rotate(15deg);
    transform-origin: top left;
    background: ${props => props.theme.globalTheme.secondary};

    ${mq('l')} {
      top: 60vh;
    }
  }

  .curtain__right {
    height: 120vh;
    width: 150vw;
    top: 50vh;
    right: 0;
    left: auto;
    transform: rotate(-50deg);
    transform-origin: top right;
    background: ${props => props.theme.globalTheme.tertiary};

    ${mq('l')} {
      height: 120vh;
      width: 150vw;
      top: -20vh;
      right: 0;
    }
  }
`;

export default StyledCurtain;
